import { observable, action, makeObservable } from 'mobx';

import type { Assistant } from '../types';

export class TimingAssistants {
  resourceParams = {
    limit: 5000,
    search: 'roles.name:assistant',
    searchFields: 'roles.name:=;created_by:=',
    searchJoin: 'AND',
  };

  @observable
  values: Array<Assistant> = [];

  @observable
  selectedValues: Array<Assistant> = [];

  constructor() {
    makeObservable(this);
  }

  @action
  addValues(values: Array<Assistant>) {
    this.values = values.map((newValue) => {
      const oldValue = this.values.find((value) => value.id === newValue.id);
      return oldValue || newValue;
    });
  }

  @action
  selectValue(value: Assistant) {
    this.selectedValues.push(value);
  }

  @action
  clearSelected() {
    this.selectedValues = [];
  }
  @action
  clearValues() {
    this.values = [];
  }
}

export const timingAssistants = new TimingAssistants();
